import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import {
  CategoryGetForDropDownSlice,
  CategoryGetSlice,
} from "../../../redux/features/CategorySlice";
import Skeleton from "react-loading-skeleton";
import { TbEditCircle } from "react-icons/tb";
import { State } from "country-state-city";
import Editor from "../../../common/Editor/Editor";
import { ArticleCreateSlice } from "../../../redux/features/Publish Article By Admin Slices/ArticleSlice";
import usePublishArticle from "../../../components/PublishNewArticleCreate";
import { toast } from "react-toastify";
import { SubCategoryGetSlice } from "../../../redux/features/Sub Category Slice/SubCategorySlice";

const PublishNewsArticle = () => {
  const navigate = useNavigate();
  const { handleUpload, handleChangeRegion,handleChangeRegionForMeraCity} = usePublishArticle();

  const [selectedRegion, setSelectedRegion] = useState({
    state: null,
    city: null,
    meraState:null,
    meraCity:null,
    category: null,
    subcategory: null,
  });

  const [imageLoading, setImageLoading] = useState(false);
  const [iState, setUpdate] = useState({
    headline: "",
    content: "",
    language: "",
    summary: "",
    oneSummary: "",
    category: "",
    subcategory: "",//renamed by quixDynamic
    state: "",
    district: "",
    images: [],
    isTrending: false,
  });
  const [stateArr, setStateArr] = useState([]);
  const [meraStateArr, setMeraStateArr] = useState([]);
  const [cityArr, setCityArr] = useState([]);
  const [MeraCityArr, setMeraCityArr] = useState([]);
  const dispatch = useDispatch();
  const { CategoryForDropDown } = useSelector((state) => state.Category);
  const { AllSubCategory } = useSelector((state) => state.SubCategory);

  const [quixDynamic,setQuixDynamic] = useState(false);
  const [option, setOption] = useState({ options: [] });
  const [errors, setErrors] = useState({});
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  
    const languageOptions = [
      { value: "en", label: "ENGLISH" },
      { value: "hi", label: "HINDI" },
      { value: "mr", label: "MARATHI" },
      { value: "pa", label: "PUNJABLI" },
      { value: "bn", label: "BENGALI" },
      { value: "as", label: "ASSAMESE" },
      { value: "te", label: "TELUGU" },
      { value: "kn", label: "KANNADA" },
      { value: "ml", label: "MALYALAM" },
      { value: "ta", label: "TAMIL" },
    ];

  useEffect(() => {
    const indiaStates = State.getStatesOfCountry("IN");
    setStateArr(
      indiaStates.map((item) => ({ value: item?.isoCode, label: item?.name }))
    );
    setMeraStateArr(
      indiaStates.map((item) => ({ value: item?.isoCode, label: item?.name }))
    );
  }, []);

  useEffect(() => {
    dispatch(CategoryGetForDropDownSlice());
    dispatch(SubCategoryGetSlice());
  }, []);

  useEffect(() => {
    const option = CategoryForDropDown?.map((item, index) => ({
      value: item?.catName,
      label: item?.catName,
    }));
    setOption((prev) => ({ ...prev, options: option }));
  }, [CategoryForDropDown]);

  useEffect(() => {
    const option = AllSubCategory?.map((item, index) => ({
      value: item?.subcatName,
      label: item?.subcatName,
    }));
    setOption((prev) => ({ ...prev, subcatoptions: option }));
  }, [AllSubCategory]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    setUpdate((prev) => ({ ...prev, [name]: value }));
  };

  useEffect(()=>{
    if(iState.summary.split(" ")?.length > 60) {
      setErrors((prev) => ({ ...prev, summary: "Please Enter Only 60 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, summary: "" }));
    }

    if(iState.oneSummary.split(" ")?.length > 30) {
      setErrors((prev) => ({ ...prev, oneSummary: "Please Enter Only 30 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, oneSummary: "" }));
    }

    if(iState.headline.split(" ")?.length > 30  ) {
      setErrors((prev) => ({ ...prev, headline: "Please Enter Only 30 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, headline: "" }));
    }    
    
    if(iState.category?.length === 0  ) {
      setErrors((prev) => ({ ...prev, category: "Please Enter Only 30 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, category: "" }));
    }    
    
    // if(iState.content?.length === 0  ) {
    //   setErrors((prev) => ({ ...prev, content: "Please Enter Only 30 Words" }));
    // } else {
    //   setErrors((prev) => ({ ...prev, content: "" }));
    // }    
    
    if(iState.state?.length === 0  ) {
      setErrors((prev) => ({ ...prev, state: "Please Enter Only 30 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, state: "" }));
    }    
    
    if(iState.district?.length === 30  ) {
      setErrors((prev) => ({ ...prev, district: "Please Enter Only 30 Words" }));
    } else {
      setErrors((prev) => ({ ...prev, district: "" }));
    }    
    
    // if(iState.language?.length === 0  ) {
    //   setErrors((prev) => ({ ...prev, language: "Please Select Language" }));
    // } else {
    //   setErrors((prev) => ({ ...prev, language: "" }));
    // }    
    
  },[iState])

  useEffect(() => {
    setUpdate((prev) => ({
      ...prev,
      state: selectedRegion?.state?.label,
      district: selectedRegion?.city?.value,
      category: selectedRegion?.category?.value,
      subcategory: selectedRegion?.subcategory?.value,
    }));
  }, [selectedRegion]);

  const isEditorEmpty = (htmlContent) => {
    // Remove empty tags and whitespace
    if (!htmlContent || typeof htmlContent !== "string") return true;

    const cleaned = htmlContent
      ?.replace(/<p><br><\/p>/gi, '')      // remove <p><br></p>
      ?.replace(/<[^>]+>/g, '')            // remove other HTML tags
      ?.replace(/&nbsp;/g, '')             // remove non-breaking spaces
      ?.trim();
  
    return cleaned.length === 0;
  };
  

  const handleSubmit = async () => {

    console.log("iState:",iState);

    if(iState?.headline?.length === 0){
      setErrors((prev) => ({ ...prev, headline: "Please Enter Headline" }));
      toast.error("Please Enter Headline");
      return;
    }

    if(iState?.category?.length === 0 || iState?.category === null || iState?.category === undefined){
      setErrors((prev) => ({ ...prev, category: "Please Enter Category" }));
      toast.error("Please Enter Category");
      return;
    }

    if(quixDynamic && (iState?.subcategory?.length === 0 || iState?.subcategory === null || iState?.subcategory === undefined)){
      setErrors((prev) => ({ ...prev, subcategory: "Please Enter Quix Dynamic" }));
      toast.error("Please Enter Quix Dynamic");
      return;
    }

    if(iState?.content?.length === 0){
      setErrors((prev) => ({ ...prev, content: "Please Enter Content" }));
      toast.error("Please Enter Content");
      return;
    }

    if(iState?.summary?.length === 0){
      setErrors((prev) => ({ ...prev, summary: "Please Enter Summary" }));
      toast.error("Please Enter Summary");
      return;
    }
    

    if(iState?.oneSummary?.length === 0){
      setErrors((prev) => ({ ...prev, oneSummary: "Please Enter One Summary" }));
      toast.error("Please Enter One Summary");
      return;
    }


    if(iState?.state?.length === 0 || iState?.state === null || iState?.state === undefined){
      setErrors((prev) => ({ ...prev, state: "Please Enter State" }));
      toast.error("Please Enter State");
      return;
    }

    if(iState?.district?.length === 0 || iState?.district === null || iState?.district === undefined){
      setErrors((prev) => ({ ...prev, district: "Please Enter District" }));
      toast.error("Please Enter District");
      return;
    }

    if(iState?.images?.length === 0){
      setErrors((prev) => ({ ...prev, images: "Please Upload Images" }));
      toast.error("Please Upload Images");
      return;
    }

    if(iState?.language?.length === 0 || iState?.language === null || iState?.language === undefined){
      setErrors((prev) => ({ ...prev, language: "Please Select Language" }));
      toast.error("Please Select Language");
      return;
    }

    console.log("quixDynamic:",quixDynamic);
    
     if(
      !(errors?.headline?.length === 0) ||
      !(errors?.summary?.length === 0) || 
      !(errors?.oneSummary?.length === 0) || 
      !(errors?.category?.length === 0) ||
      !(errors?.state?.length === 0) ||
      !(errors?.district?.length === 0)
    ){
      // console.log('called')
      return;
    }

    console.log("submitted");

    // dispatch(ArticleCreateSlice(iState)).then((res) => {
    //   console.log(res);
    //   if (res.payload?.customStatus === 201) {
    //     navigate("/ContentManagement/PublishArticleByAdmin/AllPendingArticles/1");
    //   }
    // });

    try {
      const result = await dispatch(ArticleCreateSlice(iState)).unwrap();
      // toast.success("Article created successfully!");
      console.log(result);
      if (result.customStatus === 201) {
        navigate("/ContentManagement/PublishArticleByAdmin/AllPendingArticles");
  }
    } catch (error) {
      console.log(error);
      toast.error(error?.message || "An error occurred");
      // error.errors contains validation errors if any
    }

  };

  useEffect(() => {
    console.log("selectedLanguage:",selectedLanguage);
    if(selectedLanguage?.value){
      setUpdate((prev) => ({ ...prev, language: selectedLanguage?.value }));
    }
  }, [selectedLanguage]);

  return (
    <>
      <>
        <div className="TitleBox">
          <h4 className="Title">Content Management</h4>
          <Link className="TitleLink" to={-1}>
            <i className="fa fa-arrow-left" /> Back
          </Link>
        </div>
        <div className="Small-Wrapper">
          {/* <div class="TitleBox"> 
              <h4 class="Title">Add News Article</h4> 
          </div> */}
          <div className="CommonForm">
            <h4>Add News Article</h4>
            <div className="row">
              <div className="col-sm-8">
                <div className="row">
                  <div className="col-sm-6 mb-4">
                    <div className="d-flex ">
                      <label className="Radioboxs mr-3 ">
                        <input
                          type="radio"
                          name="radio"
                          onChange={(e) =>{
                            const value = !iState?.isTrending;
                            setUpdate((prev) => ({ ...prev, isTrending: value })) 
                          }
                          }
                          checked={iState?.isTrending}
                        />
                        <span
                          className="checkmark ml-2 mt-1"
                          style={{ height: "20px", width: "20px" }}
                        />
                        Trending Article
                      </label>

                      <label className="Radioboxs ">
                        <input
                          type="checkbox"
                          name="quixDynamic"
                          onChange={(e) =>
                            setQuixDynamic(!quixDynamic)
                          }
                          checked={quixDynamic}
                        />
                        <span
                          className="checkmark ml-2 mt-1"
                          style={{ height: "20px", width: "20px" }}
                        />
                        {quixDynamic ? "Disable Quix Dynamic" : "Enable Quix Dynamic"}
                      </label>

                    </div>
                     <div className="form-group">
                                      <label>Select Language</label>
                                      <Select
                                        options={languageOptions}
                                        value={selectedLanguage}
                                        onChange={(e) => setSelectedLanguage(e)}
                                        isSearchable={true}
                                        placeholder="Select Language"
                                      />
                                    </div>

                                    {errors.language && (
                                      <div className="text-danger">
                                        {errors.language}
                                      </div>
                                    )}
                  </div>
                  <div className="col-sm-6 mb-4">
                    {/* <div className="Checkboxs">
                        <label className="CheckBox">
                          Add in Key Learning
                          <input
                            type="checkbox"
                            onChange={(e) =>
                              setUpdate((prev) => ({
                                ...prev,
                                isKeyLearning: !prev["isKeyLearning"],
                              }))
                            }
                          />
                          <span className="checkmark" />
                        </label>
                      </div> */}
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>News Headline</label>
                      <input
                        type="text"
                        className="form-control"
                        name="headline"
                        onChange={handleChange}
                        placeholder="Enter News Heading"
                      />
                      {errors.headline && (
                        <p style={{ color: "red" }}>{errors.headline}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Select News Category</label>
                      <Select
                        options={option?.options}
                        value={selectedRegion?.category}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({
                            ...prev,
                            category: e,
                          }))
                        }
                        isSearchable={true}
                        placeholder="Choose a category..."
                      />
                      {errors.category && (
                        <p style={{ color: "red" }}>{errors.category}</p>
                      )}
                    </div>
                  </div>

                  {quixDynamic && (
                    <div className="col-sm-12">
                    <div className="form-group">
                      <label>Quix Dynamic</label>
                      <Select
                        options={option?.subcatoptions}
                        value={selectedRegion?.subcategory}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({
                            ...prev,
                            subcategory: e,
                          }))
                        }
                        isSearchable={true}
                        placeholder="Quix Dynamic..."
                      />
                      {errors.subcategory && (
                        <p style={{ color: "red" }}>{errors.category}</p>
                      )}
                    </div>
                  </div>
                  )}
                  
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label>News Content</label>
                      <Editor
                        setUpdate={setUpdate}
                        type="content"
                        contentData={iState?.content}
                      />
                      {errors.content && (
                        <p style={{ color: "red" }}>{errors.content}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label>Upload Images/Video </label>
                  <div className="UploadBox">
                    <div className="Upload" style={{ padding: "0" }}>
                      {imageLoading ? (
                        <Skeleton width={"100%"} height={"130px"} />
                      ) : iState?.images?.length > 0 ? (
                        <div
                          style={{
                            height: "100%",
                            width: "100%",
                            position: "relative",
                          }}
                        >
                          <img
                            src={iState?.images}
                            style={{ height: "100%", width: "100%" }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "10px",
                            }}
                          >
                            <input
                              type="file"
                              name="images"
                              accept=".jpg, .jpeg, .png"
                              onChange={(e) =>
                                handleUpload({ e, setImageLoading, setUpdate })
                              }
                              style={{
                                height: "100%",
                                width: "100%",
                                opacity: "0",
                              }}
                              className="file-input"
                            />
                            <TbEditCircle
                              style={{
                                fontSize: "20px",
                                backgroundColor: "gray",
                                color: "wheat",
                                cursor: "pointer",
                                borderRadius: "10px",
                              }}
                            />
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={{ marginTop: "30px" }}>
                            <i className="fa fa-upload" /> <span>Upload </span>
                          </div>

                          <input
                            type="file"
                            name="images"
                            accept=".jpg, .jpeg, .png"
                            className="file-input"
                            onChange={(e) =>
                              handleUpload({ e, setImageLoading, setUpdate })
                            }
                          />
                        </>
                      )}
                    </div>
                    <div className="text-danger mt-2" style={{ fontSize: "12px", fontWeight: "600" }}>
                        * Note: Please upload images with exactly 300x800 dimensions.
                      </div>
                  </div>
                </div>
                <div style={{position:'relative',border:'1px solid black',marginTop:'30px',paddingTop:'20px',borderRadius:'3px'}}>
                  <p style={{position:'absolute',top:'-13px',left:'10px',backgroundColor:'white',paddingLeft:'5px',paddingRight:'5px'}}>
                    Select State and City
                  </p>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Select State</label>
                      <Select
                        options={stateArr}
                        value={selectedRegion?.state}
                        onChange={(e) =>
                          handleChangeRegion({
                            e,
                            setSelectedRegion,
                            setCityArr,
                          })
                        }
                        isSearchable={true}
                        placeholder="Choose a State..."
                      />
                      {errors.state && (
                        <p style={{ color: "red" }}>{errors.state}</p>
                      )}
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Select City</label>
                      <Select
                        options={cityArr}
                        value={selectedRegion?.city}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({ ...prev, city: e }))
                        }
                        isSearchable={true}
                        placeholder="Choose a City..."
                      />
                      {errors.district && (
                        <p style={{ color: "red" }}>{errors.district}</p>
                      )}
                    </div>
                  </div>
                </div>
                {/* <div style={{position:'relative',border:'1px solid black',marginTop:'30px',paddingTop:'20px',borderRadius:'3px'}}>
                  <p style={{position:'absolute',top:'-13px',left:'10px',backgroundColor:'white',paddingLeft:'5px',paddingRight:'5px'}}>
                    Select Mera City
                  </p>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Select State</label>
                      <Select
                        options={meraStateArr}
                        value={selectedRegion?.meraState}
                        onChange={(e) =>
                          handleChangeRegionForMeraCity({
                            e,
                            setSelectedRegion,
                            setMeraCityArr,
                          })
                        }
                        isSearchable={true}
                        placeholder="Choose a State..."
                      />
                      {errors.state && (
                        <p style={{ color: "red" }}>{errors.state}</p>
                      )}
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <div class="form-group">
                      <label>Select City</label>
                      <Select
                        options={MeraCityArr}
                        value={selectedRegion?.meraCity}
                        onChange={(e) =>
                          setSelectedRegion((prev) => ({ ...prev, meraCity: e }))
                        }
                        isSearchable={true}
                        placeholder="Choose a City..."
                      />
                      {errors.district && (
                        <p style={{ color: "red" }}>{errors.district}</p>
                      )}
                    </div>
                  </div>
                </div> */}
              </div>

              <div className="col-sm-8">
                <div className="form-group">
                  <label>News 60 words summary</label>
                  <Editor
                    setUpdate={setUpdate}
                    type="summary"
                    contentData={iState?.summary}
                  />
                  {errors.summary && (
                    <p style={{ color: "red" }}>{errors.summary}</p>
                  )}
                </div>
              </div>
              <div className="col-sm-8">
                <div className="form-group">
                  <label>One line summary</label>
                  <Editor
                    setUpdate={setUpdate}
                    type="oneSummary"
                    contentData={iState?.oneSummary}
                  />
                  {errors.oneSummary && (
                    <p style={{ color: "red" }}>{errors.oneSummary}</p>
                  )}
                </div>
              </div>
            </div>
            <button className="Button" onClick={handleSubmit}>
              Create
            </button>
          </div>
        </div>
      </>
    </>
  );
};

export default PublishNewsArticle;
